import { addressRepository } from "@/db/repositories/address.repository";
import { QSO } from "@/types/qso.types";
import { AddressMatch } from "@/types/excel.types";
import { checkCallInAddress } from "@/utils/string.utils";

export class AddressMatcherService {
  async matchAddresses(qsos: QSO[]): Promise<AddressMatch[]> {
    const calls = [...new Set(qsos.map((qso) => qso.call))];

    const addresses = await addressRepository.findByCalls(calls);

    const validAddresses = addresses.filter((addr) => addr.status === "valid");

    const qsoCounts = this.countQSOsByCall(qsos);

    const matches = validAddresses.map((addr) => ({
      address: addr,
      qsoCount: qsoCounts[addr.call] || 0,
    }));

    return matches;
  }

  private countQSOsByCall(qsos: QSO[]): Record<string, number> {
    return qsos.reduce(
      (acc, qso) => {
        acc[qso.call] = (acc[qso.call] || 0) + 1;
        return acc;
      },
      {} as Record<string, number>
    );
  }

  checkCallInAddress(addressText: string, call: string): boolean {
    return checkCallInAddress(addressText, call);
  }
}
